<template>
  <div class="placeholder-page center">
    <img
      :width="width"
      :src="require('@/assets/images/placeholder/' + placeholderImg + '.png')"
      alt=""
    />
    <slot>
      <p class="text">{{ placeholderText }}</p>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    placeholderImg: {
      type: String,
      default: 'blank-content',
    },
    placeholderText: {
      type: String,
      default: '暂无数据',
    },
    width: {
      type: [String, Number],
      default: '100%',
    },
  },
};
</script>

<style lang="less">
.placeholder-page {
  margin-top: 96px;
  .text {
    color: #bbb;
    line-height: 22px;
    margin-top: 0;
  }
}
</style>
